import type { PublicationCode } from '@/scopes/common/domain/types'

export function getShowRecommendedAccos(publicationCode: PublicationCode): boolean {
  return publicationCode === 'SZ'
}
